import IconButton from "../../components/button/IconButton";
import * as React from "react";
import {ButtonGroup} from "react-bootstrap";
import ConfirmIconButton from "../../components/button/ConfirmIconButton";
import {Actions} from "../../../client/Actions";
import {useState} from "react";
import ModalForm from "../../components/form/ModalForm";
import fields from "./FastActingPartQuantityAddFormConfig";
import FastActingPartQuantityMinusFormConfig from "./FastActingPartQuantityMinusFormConfig";
import Table from "../../components/table/Table";
import FastActingPartQuantityHistoryTableConfig from "./FastActingPartQuantityHistoryTableConfig";
import {hasFastActingPartFullAccess} from "../../helpers/jwt";
import {useTranslation} from 'react-i18next';

export function FastActionPartsTableActions(props) {
    const [showAddModal, setShowAddModal] = useState(false);
    const [showMinusModal, setShowMinusModal] = useState(false);
    const {t} = useTranslation();

    const buttonSize = "md"

    return <div className={"d-flex"}>
        <ButtonGroup>

            <IconButton
                variant={"outline-primary"}
                // className="btn-circle ml-1"
                onClick={props.onSelected}
                size={buttonSize}
                tooltip={t("tooltips.details")}
                icon={"fa-arrow-right "}
            />
            {hasFastActingPartFullAccess() &&
                <>
                    <IconButton
                        variant={"outline-primary"}
                        onClick={() => {
                            setShowAddModal(true)
                        }}
                        size={buttonSize}
                        tooltip={t("tooltips.introduce_to_warehouse")}
                        fullIcon={"fa-solid fa-arrow-up-from-bracket"}
                    />
                    <IconButton
                        variant={"outline-primary"}
                        onClick={() => {
                            setShowMinusModal(true)
                        }}
                        size={buttonSize}
                        tooltip={t("common.issues_history")}
                        fullIcon={"fa-solid fa-arrow-down"}
                    />
                    <ConfirmIconButton
                        variant={"outline-primary"}
                        onClick={props.onRemove}
                        size={buttonSize}
                        tooltip={t("tooltips.delete")}
                        fullIcon={"fa-regular fa-trash-can"}
                        confirmTitle={t("confirmations.are_you_sure_delete_part")}
                        confirmDescription={t("confirmations.are_you_sure_delete_part")}
                        onConfirm={() => {
                            props.setLoader(true)
                            Actions.delete("fastActingPart/" + props.row.id, {}, () => {
                                props.setReload(!props.reload)
                            })
                        }}

                        modalSize={'md'}
                    />
                </>
            }
            <ConfirmIconButton
                confirmTitle={t("common.issues_history")}
                size={"md"}
                tooltip={t("tooltips.issues_history")}
                variant={"outline-primary"}
                icon={"fa-clock-rotate-left"}
                modalSize={"xl"}
                alert={true}
                modelChildren={
                    <Table
                        source={"fastActingPart/" + props.row.id + "/quantity/history"}
                        additionalFilter={function (row) {
                            return row.fastActingPartQuantityOperation === "OUT"
                        }}
                        setLoader={props.setLoader}
                        columns={FastActingPartQuantityHistoryTableConfig}
                    />
                }

            />
        </ButtonGroup>

        <ModalForm

            open={showAddModal}
            setOpen={setShowAddModal}
            shadow={false}
            initialData={
                {
                    oldQuantity: props.row.quantity
                }
            }
            setLoader={props.setLoader}
            fields={fields(t)}
            title={t("forms.add_to_warehouse")}
            size={"md"}
            api={"/fastActingPart/" + props.row.id + "/quantity"}
            onFinish={() => {
                props.setReload(!props.reload)
            }}
        />

        <ModalForm

            open={showMinusModal}
            setOpen={setShowMinusModal}
            shadow={false}
            initialData={
                {
                    oldQuantity: props.row.quantity
                }
            }
            setLoader={props.setLoader}
            fields={FastActingPartQuantityMinusFormConfig(t)}
            title={t("common.issues_history")}
            size={"md"}
            api={"/fastActingPart/" + props.row.id + "/quantity"}
            onFinish={() => {
                props.setReload(!props.reload)
            }}
        />
    </div>;
}